import React, {Fragment} from "react";
import ModalConfirm from "../../../components/ModalConfirm";
import ModalMsg from "../../../components/ModalMsg";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import NsButtonAction from "../../../components/buttons/NsButtonAction";
import NsButtonActionsGroup from "../../../components/buttons/NsButtonActionsGroup";
import Sidebar from "../../../components/Sidebar";
import NsAccordion from "../../../components/accordion/NsAccordion";

export default function ConfStrutturaClassiImpExpView({
                                                          data,
                                                          showConfirm,
                                                          setShowConfirm,
                                                          eliminaStrClasse,
                                                          translate,
                                                          strImpExpSel,
                                                          show,
                                                          setShow,
                                                          modalMsg,
                                                          isMobile,
                                                          getAlberoStruttura,
                                                          onClickElimina,
                                                      }) {

    return (
        <Fragment>
            <ModalConfirm
                show={showConfirm}
                handleClose={() => setShowConfirm(false)}
                handleOk={eliminaStrClasse}
                testo={translate("Sicuro di voler eliminare la struttura classe: ") + (strImpExpSel && (strImpExpSel.classe_tipo_imp_exp_madre
                    + ' - ' + strImpExpSel.classe_tipo_imp_exp)) + "?"}/>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Sidebar
                sidebarContent={() => {
                    return isMobile ?
                        <NsAccordion
                            titolo={'Struttura Classi'}
                            label={'fas fa-stream'}>
                            {
                                getAlberoStruttura()
                            }
                        </NsAccordion>
                        : getAlberoStruttura()
                }}
            >
                <NsDataTable
                    data={data}
                    columns={[
                        {
                            name: translate('Classe Organizzazione Madre'),
                            selector: row => row.classe_tipo_imp_exp_madre,
                            sortable: true,
                        },
                        {
                            name: translate('Classe Organizzazione Figlia'),
                            selector: row => row.classe_tipo_imp_exp,
                            sortable: true,
                        },
                        {
                            name: '',
                            selector: row => <NsButtonActionsGroup>
                                <li>
                                    <NsButtonAction
                                        label={"Elimina"}
                                        icona={"fas fa-trash"}
                                        onClick={() => {
                                            onClickElimina(row);
                                        }}
                                    />
                                </li>
                            </NsButtonActionsGroup>,
                            sortable: false,
                            right: true,
                        }
                    ]}
                />
            </Sidebar>
        </Fragment>
    );
}